<template>
	<div v-on="$listeners" class="surf-inline-single-text surf-transition-hover-lift">
		<div class="content">
			<template v-if="isMobile">
				<div class="value text-overflow">{{ formattedItem.value }}</div>
				<div class="date">{{ normalizeYMDFormat(formattedItem.date) }}</div>
			</template>
			<template v-else>
				<div class="date">{{ normalizeYMDFormat(formattedItem.date) }}</div>
				<div class="value text-overflow">{{ formattedItem.value }}</div>
			</template>
		</div>
		<div v-if="!isMobile" class="icon">
			<SvgIcons name="surf_frame" class="frame-icon" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import SvgIcons from '@/components/SvgIcons.vue';
import { normalizeYMDFormat } from '@/utils/format';
import { useStore } from '@/utils/vue-api';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const store = useStore();
const isMobile = computed(() => store.getters.isMobileMode);

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		return { ...props.item, ...formattedData };
	}
	return props.item;
});
</script>

<style lang="less" scoped>
.surf-inline-single-text {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 14px;
	height: 64px;
	padding: 0 16px;
	border-radius: 8px;
	background-color: var(--surf-secondary-color);
	cursor: pointer;

	.content {
		flex: 1;
		display: flex;
		align-items: center;

		.date {
			width: 95px;
			color: rgba(var(--surf-inverse-color-rgb), 0.6);
			font-size: 14px;
			font-weight: 400;
			line-height: 18px;
		}

		.value {
			flex: 1;
			width: 0;
			color: var(--surf-inverse-color);
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
		}
	}

	.icon {
		display: flex;
		align-items: center;
		justify-content: center;

		.frame-icon {
			font-size: 40px;
			color: var(--surf-inverse-color) !important;
		}
	}
}

.mob-surf-layout {
	.surf-inline-single-text {
		height: 78px;
		padding: 0 12px;

		.content {
			width: 100%;
			flex-direction: column;
			align-items: flex-start;
			gap: 10px;

			.value {
				width: 100%;
				font-size: 15px;
				line-height: 20px;
			}
			.date {
				font-size: 12px;
				line-height: 16px;
			}
		}
	}
}
</style>
